import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Corporation = (function () {
  function Id(corporationId, eager) {
    if (logComponent('Corporation')) { console.debug('Corporation Id'); }
    let params = {};
    if (eager) params.eager = true;

    return axios.get(`api/Corporation/${corporationId}`, getConfig(params));
  }

  function GetAll() {
    if (logComponent('Corporation')) { console.debug('Corporation GetAll'); }
    return axios.get('api/Corporation/GetAll', getConfig());
  }

  function GetAllUsers(corporationId) {
    if (logComponent('Corporation')) { console.debug('Corporation GetAllUsers'); }
    let params = { corporationId };
    return axios.get('api/Corporation/GetAllUsers', getConfig(params));
  }

  function GetAllFacilities(corporationId) {
    if (logComponent('Corporation')) { console.debug('Corporation GetAllFacilities'); }
    let params = { corporationId };
    return axios.get('api/Corporation/GetAllFacilities', getConfig(params));
  }

  function GetAllModules(corporationId) {
    if (logComponent('Corporation')) { console.debug('Corporation GetAllModules'); }
    let params = { corporationId };
    return axios.get('api/Corporation/GetAllModules', getConfig(params));
  }

  function AddOrUpdate(corporation) {
    if (logComponent('Corporation')) { console.debug('Corporation AddOrUpdate'); }
    return axios.put('api/Corporation/AddOrUpdate', corporation, getConfig());
  }

  function AddModule(corporationId, moduleId) {
    if (logComponent('Corporation')) { console.debug('Corporation AddModule'); }
    const data = { corporationId, moduleId };
    return axios.put('api/Corporation/AddModule', data, getConfig());
  }

  function RemoveModule(corporationId, moduleId) {
    if (logComponent('Corporation')) { console.debug('Corporation RemoveModule'); }
    const data = { corporationId, moduleId };
    return axios.delete('api/Corporation/RemoveModule', getConfig(null, data));
  }

  function GetLogo(corporationId) {
    if (logComponent('Corporation')) { console.debug('Corporation GetLogo'); }
    return axios.get(`api/Corporation/Logo/${corporationId}`);
  }

  function PutLogo(corporationId, logo) {
    if (logComponent('Corporation')) { console.debug('Corporation PutLogo'); }
    let config = getConfig();
    config.headers['Content-Type'] = 'multipart/form-data';

    return axios.put(`api/Corporation/Logo/${corporationId}`, logo, config);
  }


  function GetAllGroups(corporationId) {
    if (logComponent('Corporation')) { console.debug('Corporation GetAllGroups'); }
    const params = { corporationId };
    return axios.get('api/Corporation/GetAllGroups', getConfig(params));
  }


  return {
    Id,
    GetAll,
    GetAllUsers,
    GetAllFacilities,
    GetAllGroups,
    GetAllModules,
    AddOrUpdate,
    AddModule,
    RemoveModule,
    Logo: {
      Id: {
        get: GetLogo,
        put: PutLogo
      }
    }
  }
})();

export default Corporation;